'use client';

import { SpotMarketConfig } from '@velocity-exchange/sdk';
import React from 'react';
import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import Button from 'src/components/primitives/Button/Button';
import UnstakeFormContent from 'src/components/Staking/UnstakeFormContent';
import useUnstakeForm from 'src/components/Staking/hooks/useUnstakeForm';

interface Props {
	onConfirm: () => void;
	isVelocityStaking: boolean | undefined;
	selectedIfStakeMarket: SpotMarketConfig;
}

const UnstakeModalContent = ({
	onConfirm,
	isVelocityStaking,
	selectedIfStakeMarket,
}: Props) => {
	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...unstakeFormProps
	} = useUnstakeForm({
		isVelocityStaking,
		defaultSelectedMarket: selectedIfStakeMarket,
		onConfirm,
	});

	return (
		<>
			<BaseModal.Body>
				<UnstakeFormContent
					isVelocityStaking={isVelocityStaking}
					isSubmitting={isSubmitting}
					{...unstakeFormProps}
				/>
			</BaseModal.Body>
			<BaseModal.Footer>
				<Button
					size="md"
					variant="secondary"
					className="w-full"
					disabled={isSubmitDisabled}
					isLoading={isSubmitting}
					onClick={handleSubmit}
				>
					{submitButtonContent}
				</Button>
			</BaseModal.Footer>
		</>
	);
};

export default React.memo(UnstakeModalContent);
